import React from "react"
import * as ShareStyles from "./ShareBlock.module.scss"
import Button from "../button/Button"
import Icon from "../icon/Icon"
import PropType from "prop-types"
import { site } from "../../../../../utils/site"

const ShareBlock = (props) => {
  return (
    <div className={`${ShareStyles.shareBlock} ${props.className}`}>
     <span className={site === "rh" ? ShareStyles.share : ShareStyles.shares}>Partager</span>
      <a
        href={`https://www.linkedin.com/shareArticle?mini=true&url=${props.url}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        <Icon
          icon="linkedin"
          width="16"
          height="16"
          color="var(--icon-share-color)"
        />
      </a>
      <a
        href={`https://twitter.com/intent/tweet/?url=${props.url}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        <Icon
          icon="twitter"
          width="16"
          height="16"
          color="var(--icon-share-color)"
        />
      </a>
      <a
        href={`https://www.facebook.com/sharer/sharer.php?u=${props.url}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        <Icon
          icon="facebook"
          width="16"
          height="16"
          color="var(--icon-share-color)"
        />
      </a>
      <Button
        aspect="unstyled"
        onClick={() => {
          navigator.clipboard.writeText(props.url)
        }}
      >
        <Icon
          icon="linkalt"
          width="16"
          height="16"
          color="var(--icon-share-color)"
        />
      </Button>
    </div>
  )
}

ShareBlock.propTypes = {
  url: PropType.string.isRequired,
  className: PropType.string,
}

ShareBlock.defaultProps = {
  className: "",
}

export default ShareBlock
